<template> 
    <div class="audience">
        <!-- Banner -->
        <Banner name="banner_audience" />

        <!-- 自有购买列表 -->
        <div class="owner">
            <div class="owner-bg">
                <div class="audience-title">{{ ownerData.title }}</div>
                <div class="audience-summary">{{ ownerData.summary }}</div>
                <div class="owner-conent">
                    <div v-for="(item, index) in ownerData.list" :key="index" class="item">
                        <div class="item-title">
                            <div class="title">{{ item.title }}</div>
                            <span class="tag" 
                                 :style="{color: item.tag_color,
                                          backgroundColor: index == 0 ? '#FCF8E6' : '#F7F3FE'}">{{ item.tag }}</span>
                        </div>
                        <div class="item-price">
                            <div class="price">{{ item.price }}</div>
                            <div class="unit">/{{ item.price_unit }}</div>
                        </div>
                        <div class="item-des" v-for="content in ownerDes[index]">
                            <img src="@assets/audience/icon_gou.png" srcset="@assets/audience/icon_gou@2x.png 2x" />
                            <div class="des">{{ content }}</div>
                        </div>
                        <img src="@assets/audience/icon_ticket.png" srcset="@assets/audience/icon_ticket@2x.png 2x" class="item-icon" v-if="index == 0" />
                        <img src="@assets/audience/icon_diamond.png" srcset="@assets/audience/icon_diamond@2x.png 2x" class="item-icon" v-if="index == 1" />
                        <div class="item-btn" @click="openNewPage(item.link_url)">{{ item.button }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 重要購票須知 -->
        <div class="center">
            <div class="audience-title">{{ centerData.title }}</div>
            <div class="center-list">
                <div v-for="(item, index) in centerData.list" :key="index">
                    <div class="item" v-if="index < 3" @click="handleClick(item.link_url)">
                        <div class="item-title">
                            <div class="item-img"> <img :src="item.image_url" alt=""> </div>
                            <div class="title">{{ item.title }}</div>
                        </div>
                        <div class="item-summary">{{ item.summary }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 其他合作商 -->
        <div class="other">
            <div class="audience-summary">{{ otherData.title }}</div>
            <div class="other-list">
                <div v-for="(item, index) in otherData.list" :key="index" class="item">
                     <img :src="item.image_url" alt="">
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
    import Banner from '@/components/banner/index.vue'
    import { onMounted, ref } from 'vue';
    import { ConfigGetAPI } from '@/api/common.js';
    import { useRouter } from 'vue-router'
    const router = useRouter()
     // 语言包
    const language = localStorage.getItem("language") || "zh"
    const lang = ref({})
    import(`@/language/${language}.js`).then(data => {
        lang.value = data.default.audience
        // ownerDes.value = lang.value.ownerDes
    }) 
    
    const ownerDes = ref([
        [],
        []
    ])

    // 自有购买列表参数
    const ownerParam = ref({ name: "audience_owner_buy" })

    // 自有购买列表数据
    const ownerData = ref({})

    // 自有购买列表获取
    const getOwnerData = () => {  
        ConfigGetAPI(ownerParam.value).then(res => {
            ownerData.value = res
            ownerDes.value[0] = ownerData.value.list?.[0]?.content_list.split(';')
            ownerDes.value[1] = ownerData.value.list?.[1]?.content_list.split(';')
        });
    }

    // 重要購票須知参数
    const centerParam = ref({ name: "audience_center" })

    // 重要購票須知数据
    const centerData = ref({ list:[] })

    // 重要購票須知获取
    const getCenterData = () =>{
        ConfigGetAPI(centerParam.value).then(res=>{
            centerData.value = res
        });
    }

    // 其他合作商参数
    const otherParam = ref({ name: "audience_other_buy" })

    // 其他合作商数据
    const otherData = ref({ list:[] })

    // 其他合作商获取
    const getOtherData = () => {
        ConfigGetAPI(otherParam.value).then(res => {
            otherData.value = res
        });
    }


    onMounted(() => {
        getOwnerData();
        getCenterData();
        getOtherData();
    });

    const openNewPage = (url) => {
        window.open(url, '_blank');
    }

    // 点击跳转
    const handleClick = (path) => {
        router.push({ path })
    }

</script>

<style lang="scss" scoped>

.audience {
    &-title {
        font-family: PingFangSC-medium;
        color: #333333;
        font-weight: 500;
        font-size: 36px;
        letter-spacing: 3px;
        line-height: 56px;  
        margin-bottom: 16px;  
    }

    &-summary {
        color: #666666;
        font-weight: 400;
        font-size: 24px;
        letter-spacing: 2px;
        line-height: 40px;

    }

    .banner {
        width: 100%;
        overflow: hidden;

        .banner-img {
            width: 100%;
            object-fit: cover;
        }
    }

    .owner {
        background-color: #F8FAFC;
        padding: 100px 0 80px 0;
        
        &-bg {
            width: 1200px;
            margin: 0 auto;
        }

        &-conent {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 36px;

            .item {
                width: 588px;
                height: 488px;
                border-radius: 30px;
                background-color: #FFFFFF;
                box-shadow: 0px 8px 18px 0px rgba(67, 67, 67, 0.18);
                padding: 24px;
                box-sizing: border-box;
                border: 2px solid transparent;
                position: relative;

                &-title {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    margin-bottom: 16px;

                    .title {
                        font-family: PingFangSC-medium;
                        color: #333333;
                        font-weight: 500;
                        font-size: 28px;
                        letter-spacing: 2px;
                        margin-right: 8px;
                    }

                    .tag {
                        height: 24px;
                        line-height: 24px;
                        border-radius: 20px;
                        font-weight: 500;
                        font-size: 12px;
                        letter-spacing: 1px;
                        padding: 0 20px
                    }

                }

                &-price {
                    display: flex;
                    align-items: center;
                    padding-bottom: 16px;
                    border-bottom: 1px solid #E6E6E6;

                    
                    .price {
                        font-family: D-DIN-Bold;
                        color: #333333;
                        font-weight: 700;
                        font-size: 42px;
                        letter-spacing: 4px;
                        margin-right: 12px;
                    }

                    .unit {
                        color: #666666;
                        font-weight: 400;
                        font-size: 20px;
                        letter-spacing: 2px;
                        padding-top: 10px;
                    }

                }

                &-des {
                    display: flex;
                    margin-top: 8px;
                    width: 100%;
                    align-items: center;

                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 9px;
                    }
                    .des {
                        color: #666666;
                        font-weight: 400;
                        font-size: 20px;
                        letter-spacing: 2px;
                    }
                }

                &-icon {
                    position: absolute;
                    top: 24px;
                    right: 24px;
                }

                &-btn {
                    position: absolute;
                    bottom: 24px;
                    width: 540px;
                    height: 74px;
                    border-radius: 37px;
                    background-color: #F8FAFC;
                    line-height: 74px;
                    text-align: center;
                    color: #333333;
                    font-weight: 400;
                    font-size: 24px;
                    letter-spacing: 2px;
                    cursor: pointer;
                }

                &-btn:hover {
                    font-family: PingFangSC-medium;
                    color: #FFFFFF;
                    background: linear-gradient(90deg, rgba(19, 94, 205, 1) 0%, rgba(12, 72, 161, 1) 100%);
                }

            }

            .item:hover{
                border: 2px solid rgba(14, 80, 178, 1);
            }
        }

    }


    .center {
        background-color: #fff;
        padding: 50px 0 36px 0;
        width: 1200px;
        margin: 0 auto;
        border-bottom: 1px solid #E6E6E6;

        &-content {
            font-family: PingFangSC-regular;
            color: #333333;
            font-weight: 400;
            font-size: 24px;
            letter-spacing: 2px;
            margin-top: 10px;
        }

        &-list {
            margin-top: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;


            .item {
                width: 384px;
                border-radius: 30px;
                background-color: #F8FAFC;
                padding: 24px;
                box-sizing: border-box;
                cursor: pointer;

                &-title {
                    font-family: PingFangSC-medium;
                    color: #333333;
                    font-weight: 500;
                    font-size: 26px;
                    letter-spacing: 3px;
                    line-height: 32px;
                    display: flex;
                    align-items: center;
                    
                    .title {
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 230px;
                    }
                    
                }

                &-img {
                    width: 75px;
                    height: 75px;
                    background-color: #FFFFFF;
                    border-radius: 50%;
                    margin-right: 27px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        width: 32px;
                        height: 32px;
                    }
                }

                &-summary {
                    font-family: PingFangSC-regular;
                    color: #333333;
                    font-weight: 400;
                    font-size: 20px;
                    letter-spacing: 2px;
                    margin-top: 24px;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                &-summary:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .other {
        background-color: #fff;
        padding: 36px 0 50px 0;
        width: 1200px;
        margin: 0 auto;

        &-list {
            margin-top: 44px;
            display: flex;
            flex-wrap: wrap;
            

            .item {
                margin-right: 44px;
                margin-bottom: 10px; 

                img {
                    width: 154px;
                }
            }
            

        }
    }
}
/* 响应式布局 */
@media (max-width: 768px) {
    .audience {
        &-title {
            font-size: 18px;
            letter-spacing: 0;
            line-height: 24px;  
            margin-bottom: 12px;  
        }

        &-summary {
            font-size: 14px;
            letter-spacing: 1px;
            line-height: 20px;
        }

        .owner {
            padding: 24px 12px;
            
            &-bg {
                width: 100%;
            }

            &-conent {
                display: block;
                margin-top: 12px;

                .item {
                    width: 100%;
                    height: 268px;
                    border-radius: 10px;
                    padding: 12px;
                    position: relative;
                    margin-bottom: 10px;

                    &-title {
                        margin-bottom: 8px;

                        .title {
                            font-family: PingFangSC-medium;
                            color: #333333;
                            font-weight: 500;
                            font-size: 16px;
                            letter-spacing: 2px;
                            margin-right: 8px;
                        }

                        .tag {
                            height: 16px;
                            line-height: 16px;
                            border-radius: 10px;
                            font-size: 8px;
                            letter-spacing: 1px;
                            padding: 0 10px;
                        }

                    }

                    &-price {
                        padding-bottom: 8px;

                        .price {
                            font-weight: 700;
                            font-size: 22px;
                            letter-spacing: 1px;
                            margin-right: 6px;
                        }

                        .unit {
                            font-size: 10px;
                            letter-spacing: 0;
                            padding-top: 5px;
                        }

                    }

                    &-des {
                        margin-top: 4px;
                        width: 100%;

                        img {
                            width: 10px;
                            height: 10px;
                            margin-right: 4px;
                        }

                        .des {
                            font-size: 10px;
                            letter-spacing: 1px;
                        }
                    }

                    &-icon {
                        top: 12px;
                        right: 12px;
                        width: 20px;
                        height: 20px;
                    }

                    &-btn {
                        bottom: 12px;
                        width: calc(100% - 24px);
                        height: 40px;
                        border-radius: 37px;
                        line-height: 40px;
                        font-weight: 400;
                        font-size: 12px;
                        letter-spacing: 1px;
                    }

                    &-btn:hover {
                        font-family: PingFangSC-medium;
                        color: #FFFFFF;
                        background: linear-gradient(90deg, rgba(19, 94, 205, 1) 0%, rgba(12, 72, 161, 1) 100%);
                    }

                }

                .item:hover{
                    border: 1px solid rgba(14, 80, 178, 1);
                }
            }

        }

        .center {
            background-color: #fff;
            padding: 24px 12px;
            width: 100%;
            box-sizing: border-box;
            
            &-content {
                font-weight: 400;
                font-size: 12px;
                letter-spacing: 1px;
                margin-top: 5px;
            }

            &-list {
                margin-top: 12px;
                display: block;

                .item {
                    width: 100%;
                    border-radius: 10px;
                    padding: 12px;
                    margin-bottom: 10px;

                    &-title {
                        font-weight: 500;
                        font-size: 16px;
                        letter-spacing: 1px;
                        line-height: 45px;

                        
                        .title {
                            max-width: 80%;
                        }
                        
                    }

                    &-img {
                        width: 45px;
                        height: 45px;
                        border-radius: 50%;
                        margin-right: 10px;

                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }

                    &-summary {
                        font-weight: 400;
                        font-size: 10px;
                        letter-spacing: 1px;
                        margin-top: 12px;
                    }
                }
            }
        }

        .other {
            background-color: #fff;
            padding: 24px 12px;
            width: 100%;
            box-sizing: border-box;

            &-list {
                margin-top: 22px;

                .item {
                    margin-right: 22px;
                    margin-bottom: 10px; 

                    img {
                        width: 94px;
                    }
                }
            
            }
        }
    }
}
</style>
    

